<template>
    <div>
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            background-color="#112f50" text-color="#fff" active-text-color="#ffd04b" :collapse="isCollapse"
            @select="handleSelect">
            <el-menu-item>
                <span>当前用户角色：{{ userRole }}</span>
            </el-menu-item>
            <el-menu-item index="/">
                <i class="iconfont icon-home"></i>
                <span style="margin-left: 20px;">首页</span>
            </el-menu-item>
            <el-submenu index="/System">
                <template slot="title">
                    <i class="iconfont icon-Setting"></i>
                    <span style="margin-left: 20px;">系统管理</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="/System/userManage">用户管理</el-menu-item>
                    <el-menu-item index="/System/organizationManage">机构管理</el-menu-item>
                    <el-menu-item index="/System/vendorCodeManage">注册码管理</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-submenu index="/Product">
                <template slot="title">
                    <i class="iconfont icon-xiangmuku"></i>
                    <span style="margin-left: 20px;">项目管理</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="/Product/productManage">项目管理</el-menu-item>
                    <el-menu-item index="/Product/machineManage">项目设备管理</el-menu-item>
                    <el-menu-item index="/Product/contact">维保联系人</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-submenu index="/Log">
                <template slot="title">
                    <i class="iconfont icon-duihua"></i>
                    <span style="margin-left: 20px;">日志记录</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="/Log/callLog">呼叫记录</el-menu-item>
                    <el-menu-item index="/Log/dangerLog">告警记录</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
</template>

<script>
export default {
    props: ['isCollapse'],
    data() {
        return {
            // isCollapse:false
            userRole:''
        }
    },
    created(){
        if(JSON.parse(localStorage.getItem('userName'))[0].userLevel == 1) this.userRole = '管理员'
        else if(JSON.parse(localStorage.getItem('userName'))[0].userLevel == 2) this.userRole = '代理商'
        else if(JSON.parse(localStorage.getItem('userName'))[0].userLevel == 3) this.userRole = '客户'
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        handleSelect(key, keyPath) {
            this.$router.push({
                path: key,
                params: { data: 'query' }
            })
        }
    }
}

</script>

<style scoped>
.el-menu {
    border-right: 0;

    /deep/ .is-active {
        background-color: #1e78bf !important;
    }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
</style>